import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SortEvent } from 'primeng/api';
import { ListaBase } from '../../../shared/crud/ListaBase';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { PartnumberNaoOriginalModel } from './partnumber-nao-original.model';
import { PartnumberNaoOriginalService } from './partnumber-nao-original.service';

@Component({
  selector: 'app-partnumber-nao-original',
  templateUrl: './partnumber-nao-original.component.html',
  styleUrls: ['./partnumber-nao-original.component.css']
})
export class PartnumberNaoOriginalComponent extends ListaBase implements OnInit {

  columns: any[];
  _selectedColumns: any[];
  loading = false;
  data: PartnumberNaoOriginalModel[] = [];
  filtros: any = {};
  nomeModulo: string = 'partnumbers-nao-originais';
  totalRegistros: number = 0;
  first: number = 0;
  paginaAtual: number = 0;
  //ç


  constructor(
    service: PartnumberNaoOriginalService,
    toastr: ToastrService,
    router: Router,
    private servico: PartnumberNaoOriginalService,
    private exportExcelService: ExportExcelService
  ) {
    super(service, toastr, router);

    this.filtros = {
      partnumber: null
    };
  }

  ngOnInit() {
    this.definirColunas();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.columns.filter(col => val.includes(col));
  }

  getAll(resetarPagina: boolean = false) {
    if (resetarPagina) {
      this.first = 0;
      this.paginaAtual = 0;
    }

    const objFiltro: any = {
      filtros: []
    };

    if (this.filtros.partnumber !== undefined
      && this.filtros.partnumber !== null
      && this.filtros.partnumber.toString().trim() !== '') {

      objFiltro.filtros.push({
        nome: 'PARTNUMBER',
        valor: this.filtros.partnumber.toString().trim()
      });
    }

    this.loading = true;

    this.servico.buscar(objFiltro).then(res => {
      this.data = res && res.dados ? res.dados : [];
      this.totalRegistros = res && res.total_registros ? res.total_registros : this.data.length;
      this.loading = false;
    }).catch(() => {
      this.data = [];
      this.totalRegistros = 0;
      this.loading = false;
    });
  }

  pesquisar() {
    this.getAll(true);
  }

  private definirColunas() {
    this.columns = [
      { field: 'codDealer', header: 'COD_DEALER', width: '130px' },
      { field: 'nomeDealer', header: 'NOME DO DEALER', width: '300px' },
      { field: 'partnumber', header: 'PARTNUMBER', width: '220px' },
      { field: 'descricao', header: 'DESCRICAO', width: '400px' }
    ];

    this._selectedColumns = this.columns;
  }

  exportExcel() {
    this.exportExcelService.nomeModulo = this.nomeModulo;

    this.exportExcelService.ExportTOExcelJSON(
      (this.data || []).map(r => {
        let linha = {};

        this._selectedColumns.forEach(c => {
          linha[c.header] = r[c.field] != null ? r[c.field] : '';
        });

        return linha;
      })
    );
  }

  cleanFilter() {
    this.filtros.partnumber = null;
    this.getAll(true);
  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null) {
        result = -1;
      } else if (value1 != null && value2 == null) {
        result = 1;
      } else if (value1 == null && value2 == null) {
        result = 0;
      } else if (typeof value1 === 'string' && typeof value2 === 'string') {
        result = value1.localeCompare(value2);
      } else {
        result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
      }

      return event.order * result;
    });
  }

  onPageChange(event: any) {
    this.paginaAtual = event.page;
    this.first = event.first;
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.partnumber !== undefined
      && this.filtros.partnumber !== null
      && this.filtros.partnumber.toString().trim() !== '';
  }
}